/* 🤖 this file was generated by svg-to-ts */
export const matIconSouthEast: {
  name: 'south-east';
  data: string;
} = {
  name: 'south-east',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 9h-2v6.59L5.41 4 4 5.41 15.59 17H9v2h10V9z"/></svg>`
};
